<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <div class="row">
        <div class="col-lg-3 col-md-5 col-sm-12">
          <ts-card class="m-b-15">
            <profile />
          </ts-card>
          <ts-card>
            <change-password />
          </ts-card>
          <br />
        </div>
        <div class="col-lg-9 col-md-7 col-sm-12">
          <ts-card>
            <div class="overflow-auto">
              <ts-tabs target="gTab">
                <ts-tab>
                  <i class="fas fa-redo mr-2"></i>
                  {{ $t('homePage.request') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-book mr-2"></i>
                  {{ $t('homePage.homework') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-graduation-cap mr-2"></i>
                  {{ $t('homePage.programGrade') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-calendar-alt mr-2"></i>
                  {{ $t('homePage.schedule') }}
                </ts-tab>
                <ts-tab>
                  <i class="fas fa-bell mr-2"></i>
                  {{ $t('homePage.notificationHistory') }}
                </ts-tab>
              </ts-tabs>
            </div>
          </ts-card>
          <ts-tab-panes name="gTab">
            <ts-tab-pane>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <request />
                </div>
              </div>
            </ts-tab-pane>
            <ts-tab-pane>
              <div class="row">
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <class />
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <subject />
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                  <status />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <homework-list />
                </div>
              </div>
            </ts-tab-pane>
            <ts-tab-pane>
              <program-grade />
            </ts-tab-pane>
            <ts-tab-pane>
              <schedule />
            </ts-tab-pane>
            <ts-tab-pane>
              <notification-history />
            </ts-tab-pane>
          </ts-tab-panes>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import Profile from './components/profile'
import ChangePassword from './components/change-password'
import Request from './components/request'
import Class from './components/class'
import Subject from './components/subject'
import Status from './components/status'
import HomeworkList from './components/homework-list'
import NotificationHistory from './components/notification-history'
import ProgramGrade from './components/program-grade'
import Schedule from './components/schedule'

export default {
  name: 'teacher',
  components: {
    Profile,
    ChangePassword,
    Request,
    Class,
    Subject,
    Status,
    HomeworkList,
    NotificationHistory,
    ProgramGrade,
    Schedule
  },
  data() {
    return {
      loadingPreData: false
    }
  },
  created() {
    this.fetchProfile()
  },
  methods: {
    fetchProfile() {
      this.loadingPreData = true
      this.$store
        .dispatch('home/teacher/fetchProfile')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>
<style scoped>
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
